import { useCallback, useEffect, useState } from "react";

import { PageNavigation } from "~/components/PageNavigation";
import { useQuery } from "~/hooks/useQuery";
import { personalTrainersAtom } from "~/modules/admin/data";
import { listPersonalTrainer } from "~/modules/admin/services";
import type { PersonalTrainerQuery } from "~/modules/admin/types";
import { useAtom } from "~/observers/jotai";

import { PersonalTrainerCard } from "./components/PersonalTrainerCard";
import { context } from "./context";
import { Header } from "./Header";

export const AdminHome: React.FC = () => {
	const query = useQuery();
	const [data, setData] = useAtom(personalTrainersAtom);
	const [filter, setFilter] = useState<PersonalTrainerQuery>({
		page: 0,
		limit: 16,
		documentNumber: query.get("cpf") ?? undefined,
	});

	const handleIncrementPage = useCallback((page: number) => {
		setFilter((state) => ({ ...state, page }));
	}, []);

	const handleChangeSearch = useCallback((search: string) => {
		setFilter(() => ({
			page: 0,
			limit: 16,
			name: search,
			documentNumber: search,
		}));
	}, []);

	const handleRemoveFromList = useCallback(
		(personalTrainerId: string) => {
			const newData = { ...data };
			const newList = newData.personalTrainers.filter(
				(pt) => pt.id !== personalTrainerId,
			);
			newData.personalTrainers = newList;
			setData(newData);
		},
		[data, setData],
	);

	useEffect(() => {
		listPersonalTrainer(filter);
	}, [filter]);

	return (
		<context.Provider
			value={{ handleChangeSearch, handleRemoveFromList, filter }}
		>
			<Header />
			<div className="flex flex-col flex-1 overflow-y-hidden bg-slate-100">
				<div className="flex p-5 flex-wrap gap-4 overflow-y-auto">
					{data?.personalTrainers.map((p) => (
						<PersonalTrainerCard key={p.id} data={p} />
					))}
				</div>
				<div className="self-end mt-auto p-5">
					<PageNavigation
						currentPage={filter.page ?? 0}
						numPages={data?.meta.totalPages ?? 0}
						onPageChange={handleIncrementPage}
					/>
				</div>
			</div>
		</context.Provider>
	);
};
